"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LinkUnlinkIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "nonzero",
    d: "M7.197 8.752l.532-.513 1.178-1.177a3.625 3.625 0 015.126 0l2.21 2.21-1.945 1.944-1.767-1.768a1.5 1.5 0 00-2.122 0l-.864.865-.02-.02-.4.387-1.928-1.928zm-1.44 1.388l1.933 1.934-3.135 3.042a2.75 2.75 0 003.89 3.89l1.06-1.061 1.945 1.944-1.06 1.061a5.5 5.5 0 01-7.78-7.778l3.147-3.032zm7.601 7.602a3.626 3.626 0 01-3.948-.788l-2.21-2.21 1.58-1.58 4.578 4.578zm3.015-2.41l3.89 3.89a1 1 0 01-1.414 1.415L3.293 5.081a1 1 0 111.414-1.414l9.721 9.72 4.943-4.942a2.75 2.75 0 00-3.889-3.89l-.97.987-1.945-1.944.97-.987a5.5 5.5 0 017.779 7.778l-4.943 4.943z"
  }));
});
LinkUnlinkIcon.category = 'Content';
var _default = LinkUnlinkIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/LinkUnlinkIcon.js
// module id = 1107
// module chunks = 0